export const countryNums = {
  us: '+1',
  al: '+355',
  dz: '+213',
  af: '+93',
  ar: '+54',
  ae: '+971',
  aw: '+297',
  om: '+968',
  az: '+994',
  ac: '+247',
  eg: '+20',
  et: '+251',
  ie: '+353',
  ee: '+372',
  ad: '+376',
  ao: '+244',
  ai: '+1',
  ag: '+1',
  at: '+43',
  au: '+61',
  mo: '+853',
  bb: '+1',
  pg: '+675',
  bs: '+1',
  pk: '+92',
  py: '+595',
  ps: '+970',
  bh: '+973',
  pa: '+507',
  br: '+55',
  by: '+375',
  bm: '+1',
  bg: '+359',
  mp: '+1',
  mk: '+389',
  bj: '+229',
  be: '+32',
  is: '+354',
  pr: '+1',
  pl: '+48',
  ba: '+387',
  bo: '+591',
  bz: '+501',
  bw: '+267',
  bt: '+975',
  bf: '+226',
  bi: '+257',
  kp: '+850',
  gq: '+240',
  dk: '+45',
  de: '+49',
  tl: '+670',
  tg: '+228',
  do: '+1',
  dm: '+1',
  ru: '+7',
  ec: '+593',
  er: '+291',
  fr: '+33',
  fo: '+298',
  pf: '+689',
  gf: '+594',
  mf: '+590',
  va: '+39',
  ph: '+63',
  fj: '+679',
  fi: '+358',
  cv: '+238',
  fk: '+500',
  gm: '+220',
  cg: '+242',
  cd: '+243',
  co: '+57',
  cr: '+506',
  gd: '+1',
  gl: '+299',
  ge: '+995',
  cu: '+53',
  gp: '+590',
  gu: '+1',
  gy: '+592',
  kz: '+7',
  ht: '+509',
  kr: '+82',
  nl: '+31',
  bq: '+599',
  sx: '+1',
  me: '+382',
  hn: '+504',
  ki: '+686',
  dj: '+253',
  kg: '+996',
  gn: '+224',
  gw: '+245',
  ca: '+1',
  gh: '+233',
  ga: '+241',
  kh: '+855',
  cz: '+420',
  zw: '+263',
  cm: '+237',
  qa: '+974',
  ky: '+1',
  km: '+269',
  xk: '+383',
  ci: '+225',
  kw: '+965',
  hr: '+385',
  ke: '+254',
  ck: '+682',
  cw: '+599',
  lv: '+371',
  ls: '+266',
  la: '+856',
  lb: '+961',
  lt: '+370',
  lr: '+231',
  ly: '+218',
  li: '+423',
  re: '+262',
  lu: '+352',
  rw: '+250',
  ro: '+40',
  mg: '+261',
  mv: '+960',
  mt: '+356',
  mw: '+265',
  my: '+60',
  ml: '+223',
  mh: '+692',
  mq: '+596',
  mu: '+230',
  mr: '+222',
  us: '+1',
  as: '+1',
  vi: '+1',
  mn: '+976',
  ms: '+1',
  bd: '+880',
  pe: '+51',
  fm: '+691',
  mm: '+95',
  md: '+373',
  ma: '+212',
  mc: '+377',
  mz: '+258',
  mx: '+52',
  na: '+264',
  za: '+27',
  ss: '+211',
  nr: '+674',
  ni: '+505',
  np: '+977',
  ne: '+227',
  ng: '+234',
  nu: '+683',
  no: '+47',
  nf: '+672',
  pw: '+680',
  pt: '+351',
  jp: '+81',
  se: '+46',
  ch: '+41',
  sv: '+503',
  ws: '+685',
  rs: '+381',
  sl: '+232',
  sn: '+221',
  cy: '+357',
  sc: '+248',
  sa: '+966',
  bl: '+590',
  st: '+239',
  sh: '+290',
  kn: '+1',
  lc: '+1',
  sm: '+378',
  pm: '+508',
  vc: '+1',
  lk: '+94',
  sk: '+421',
  si: '+386',
  sz: '+268',
  sd: '+249',
  sr: '+597',
  sb: '+677',
  so: '+252',
  tj: '+992',
  tw: '+886',
  th: '+66',
  tz: '+255',
  to: '+676',
  tc: '+1',
  tt: '+1',
  tn: '+216',
  tv: '+688',
  tr: '+90',
  tm: '+993',
  tk: '+690',
  wf: '+681',
  vu: '+678',
  gt: '+502',
  ve: '+58',
  bn: '+673',
  ug: '+256',
  ua: '+380',
  uy: '+598',
  uz: '+998',
  es: '+34',
  gr: '+30',
  hk: '+852',
  sg: '+65',
  nc: '+687',
  nz: '+64',
  hu: '+36',
  sy: '+963',
  jm: '+1',
  am: '+374',
  ye: '+967',
  iq: '+964',
  ir: '+98',
  il: '+972',
  it: '+39',
  in: '+91',
  id: '+62',
  gb: '+44',
  vg: '+1',
  io: '+246',
  jo: '+962',
  vn: '+84',
  zm: '+260',
  td: '+235',
  gi: '+350',
  cl: '+56',
  cf: '+236',
  cn: '+86'
}

/**
 * 腾讯云滑块验证码AppId
 */
export const TencentCaptchaAppId = '195851482'
export const pwdPublicKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0Y5iQN3VNofXPtZXYZe975ojD+Gb+yPBrlrKj2t4XvYHE+pYmFzGPTvDmB3t1OfHujdgBVc3VJBSFsHezm4kz4iqIChHLKeFvuux+i/Uq+zo1QdC72qteUMHF925qPLe3xU/QJj6BFR9mA4VrUwXt8eWI58ozizBH31PclxiPNT+yYYXRUV3QJvbZ+FJGL3gYUu1k44WILQzDZfBJMRf+MyLHZew6+XtYB8E2+PXc/R7TtLPcMDsPvARrAJMhu5b+yfwJM1zOFChAz3U1w0Zkj1yVJQaa/aktmfd0KyFkU2M0xNpPIIcQkywUGCMZEmJkEIyyV/I+H/NvQ+qqU5llwIDAQAB`
